import { Routes } from '@angular/router';
import configuracoesArrecadacaoRoutes from '@/features/configuracoes/arrecadacao/configuracoes-arrecadacao-routes';
import configuracoesUsuarioRoutes from '@/features/configuracoes/usuario/configuracoes-usuario-routes';
import { ConfiguracoesContent } from './configuracoes-content';
import configuracoesRegistroRoutes from '@/features/configuracoes/registro/configuracoes-registro-routes';
import configuracoesGeraisRoutes from '@/features/configuracoes/geral/configuracoes-gerais-routes';
import configuracoesComissoesRoutes from '@/features/configuracoes/comissoes/configuracoes-comissoes-routes';
import configuracoesDividaAtivaRoutes from '@/features/configuracoes/dividaativa/configuracoes-divida-ativa-routes';
import { Contabilidade } from '@/features/configuracoes/contabilidade/contabilidade';
import { Refis } from '@/features/configuracoes/refis/refis';
import { Indicadores } from '@/features/configuracoes/indicadores/indicadores';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';

export const configuracoesRoutes: Routes = [
    {
        // Entrada sem guard: sempre abre e mostra o menu interno (configuracoes-content); o gate é por
        // funcionalidade (menu cinza) + botões. Backend barra os dados por role.
        path: CONFIGURACOES_ROUTES.ROOT,
        component: ConfiguracoesContent,
        data: { breadcrumb: 'Configurações' },
        children: [
            { path: '', redirectTo: CONFIGURACOES_ROUTES.GERAIS.ROOT, pathMatch: 'full' },
            { path: CONFIGURACOES_ROUTES.CONTABILIDADE, component: Contabilidade, data: { breadcrumb: 'Contabilidade' } },
            { path: CONFIGURACOES_ROUTES.REFIS, component: Refis, data: { breadcrumb: 'Refis' } },
            { path: CONFIGURACOES_ROUTES.INDICADORES, component: Indicadores, data: { breadcrumb: 'Indicadores' } },
            ...configuracoesGeraisRoutes,
            ...configuracoesArrecadacaoRoutes,
            ...configuracoesRegistroRoutes,
            ...configuracoesUsuarioRoutes,
            ...configuracoesComissoesRoutes,
            ...configuracoesDividaAtivaRoutes
        ]
    }
];

export default configuracoesRoutes;
